import { defineStore } from 'pinia'
import { TStoryPage } from '~/types/page-types'

type TStoreState = {
  visible: boolean,
  currentStory: TStoryPage | undefined
}

export const useStoriesStore = defineStore('stories', {
  state: (): TStoreState => {
    return {
      visible: false,
      currentStory: undefined
    }
  },
  actions: {
    clear () {
      this.$state.currentStory = undefined
      this.$state.visible = false
    },
    setStory (story: TStoryPage) {
      this.$state.currentStory = story
    }
  },
  getters: {
    getStory: state => state.currentStory
  }
})
